import { useState, useEffect } from 'react';

export function formatDuration(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
  
    const durationParts = [];
  
    if (hours > 0) {
      durationParts.push(`${hours}h`);
    }
  
    if (minutes > 0) {
      durationParts.push(`${minutes}m`);
    }
  
    if (remainingSeconds > 0 || durationParts.length === 0) {
      durationParts.push(`${Math.round(remainingSeconds)}s`);
    }
  
    return durationParts.join(' ');
}

export function useETA(params: { currentItem: number; totalItems: number }){
  const { currentItem, totalItems } = params;
  const [lastTime, setLastTime] = useState(new Date())
  const [estimatedTime, setEstimatedTime] = useState<number>(null);
  const [duration, setDuration] = useState<number>(0);
  const [computed, setComputed] = useState<number>(0);

  useEffect(() => {
       setLastTime(new Date());
       setEstimatedTime(null);
  }, [totalItems])

  useEffect(() => {
    if (currentItem > 0 && totalItems > 0) {
      const newTime = new Date();
      const i = computed + 1;  
      const newDuration = duration + (newTime.getTime() - lastTime.getTime())
      const timePerItem = newDuration / i;
      const newEstimatedTime = timePerItem * (totalItems - currentItem);
      
      setLastTime(newTime);
      setDuration(newDuration);
      setEstimatedTime(newEstimatedTime);
      setComputed(i);
    }
  }, [currentItem]);

  return { estimatedTime, duration };
}